<template>
    <div class="performer-tile-container">
        <router-link
            class="performer"
            :to="`performers/${artistId}`"
            :title="`${artistName}`"
        >
            <div class="performer-image-container">
                <div
                    class="performer-image"
                    :style="{ 'backgroundImage' : `url(${$store.state.isMobile ? images.rectangle : images.square})`}"
                />
                <div class="info-section">
                    <div>
                        <div class="info-section__performer">
                            {{ truncatedArtistName }}
                        </div>
                        <div class="info-section__number_events">{{ eventCount }} events</div>
                    </div>
                    <div>
                        <span class="info-section__chevron icon-chevron-lg-right"/>
                    </div>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
export default {
    props: {
        artistName: {
            required: true,
            type: String
        },
        artistId: {
            required: true,
            type: String
        },
        eventCount: {
            required: true,
            type: Number
        },
        images: {
            required: true,
            type: Object
        }
    },
    computed: {
        truncatedArtistName() {
            return this.artistName.length > 18 ? this.artistName.substring(0,18) + "..." : this.artistName;
        }
    }
}
</script>

<style lang="postcss" scoped>
@import 'theme';

.performer-tile-container {
    border-radius: 8px;
    box-sizing: border-box;
    height: 187px;
    width: 100%;

    @media (--mq-large-min) {
        height: 294px;
        width: 294px;
    }
    &:hover {
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
        cursor: pointer;
        transform: scale(1.02);
        transition: transform 0.2s ease;
    }
}
.performer {
        &:active,
        &:focus,
        &:hover {
            text-decoration: none;
        }
}
.performer-image-container {
    -webkit-background-clip: padding-box;
    background-color: var(--c-header-gradient-left);
    border-radius: 10px;
    height: 100%;
    position: relative;
    width: 100%;
}
.performer-image {
    background-position: 50% 0%;
    background-repeat: no-repeat;
    background-size: contain;
    border-radius: 8px;
    clip-path: polygon(0% 0%, 100% 0%, 100% 50%, 0% 71%);
    height: 100%;
    width: 100%;

    @media (--mq-large-min) {
        background-position: 50% 50%;
        background-size: cover;
        clip-path: polygon(0% 0%, 100% 0%, 100% 75%, 0% 82%);
    }
}

.info-section {
    align-items: center;
    border-radius: 0 0 8px 8px;
    bottom: 55px;
    color: white;
    display: flex;
    height: 55px;
    justify-content: space-between;
    margin: 0;
    padding: 8px 13px 8px 8px;
    position: relative;
    text-align: left;
    white-space: normal;
    width: 100%;
    z-index: 20;

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        padding: 24px 13px 20px 8px;
        background-color: var(--c-header-gradient-left);
    }

    & .info-section__performer {
        font-size: 20px;
        font-weight: 600;
    }

    & .info-section__number_events {
        font-size: 12px;
    }

    & .info-section__chevron {
        bottom: 4px;
        font-size: 24px;
        position: relative;

        @media (--mq-large-min) {
            font-size: 20px;
        }
    }
}
</style>
